export default __webpack_public_path__ + "static/media/vip-3.750e71b6.webp";